import { render, staticRenderFns } from "./_TotalWrapper.vue?vue&type=template&id=0e805ff7"
import script from "./_TotalWrapper.vue?vue&type=script&lang=js"
export * from "./_TotalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports